import * as Bixby from '$/core';

export abstract class DataSiteService {
  private static baseUrl = `${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_DATASITESCONTROLLER}`;

  public static async getAllSummariesByDataSiteName(dataSiteSearch: string): Promise<Bixby.Models.ClientDataSiteReconciliationSummary[]> {
    const sanitizedStr = encodeURIComponent(dataSiteSearch);
    const baseUrl = `${DataSiteService.baseUrl}/${Bixby.Constants.API_ACTION_SEARCH}`;
    const map: any = {};
    map[Bixby.Constants.API_PARAMS_SEARCHNAME] = sanitizedStr;
    const url = `${baseUrl}${Bixby.Utils.objectToQueryString(map)}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    const results: Bixby.Models.ClientDataSiteReconciliationSummary[] = await Bixby.API.get(route);
    return results;
  }

  public static async getAllMnpiSummariesByDataSiteName(dataSiteSearch: string): Promise<Bixby.Models.ClientDataSiteReconciliationSummary[]> {
    const sanitizedStr = encodeURIComponent(dataSiteSearch);
    const baseUrl = `${DataSiteService.baseUrl}/${Bixby.Constants.API_ACTION_SEARCH_MNPI}`;
    const map: any = {};
    map[Bixby.Constants.API_PARAMS_SEARCHNAME] = sanitizedStr;
    const url = `${baseUrl}${Bixby.Utils.objectToQueryString(map)}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    const results: Bixby.Models.ClientDataSiteReconciliationSummary[] = await Bixby.API.get(route);
    return results;
  }

  public static async uploadDataSites(dataSitesFile: Bixby.Models.ClientDataSiteVerificationSummary[]): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(`${DataSiteService.baseUrl}`);
    return await Bixby.API.postJSON(route, dataSitesFile);
  }

  public static async uploadMnpiDataSites(dataSitesFile: Bixby.Models.ClientDataSiteVerificationSummary[]): Promise<void> {
    const route = Bixby.API.ServerRoute.forAction(`${DataSiteService.baseUrl}/mnpi`);
    return await Bixby.API.postJSON(route, dataSitesFile);
  }

  public static async verifyDataSites(dataSitesFile: Blob): Promise<Bixby.Models.ClientDataSiteVerificationSummary[]> {
    const route = Bixby.API.ServerRoute.forAction(`${DataSiteService.baseUrl}/verify`);

    const formData = new FormData();
    formData.set('dataSitesFile', dataSitesFile);

    return await Bixby.API.postJSON(route, formData);
  }

  public static async verifyMnpiDataSites(dataSitesFile: Blob): Promise<Bixby.Models.ClientDataSiteVerificationSummary[]> {
    const route = Bixby.API.ServerRoute.forAction(`${DataSiteService.baseUrl}/verify/mnpi`);

    const formData = new FormData();
    formData.set('dataSitesFile', dataSitesFile);

    return await Bixby.API.postJSON(route, formData);
  }

  public static async getDataSiteDocumentsAsync(filter: Bixby.Enums.DataSiteDocumentFilter): Promise<Bixby.Models.DataSiteDocument[]> {
    const sanitizedStr = encodeURIComponent(filter);
    const baseUrl = `${DataSiteService.baseUrl}/${Bixby.Constants.API_ACTION_DOCUMENTS}`;
    const map: any = {};
    map[Bixby.Constants.API_PARAMS_FILTER] = sanitizedStr;
    const url = `${baseUrl}${Bixby.Utils.objectToQueryString(map)}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.get(route);
  }

  public static async downloadDataSiteDocumentsAsync(dateSiteFiles: string[]): Promise<Bixby.Models.FileResultMetadata> {
    const url = `${DataSiteService.baseUrl}/${Bixby.Constants.API_ACTION_DOCUMENTS}/${Bixby.Constants.API_ACTION_DOWNLOAD}`;
    const formData = new FormData();
    formData.set('request', JSON.stringify(dateSiteFiles));
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.postFileWithMetadata(route, formData);
  }
}
